import { ProjectColoredLink } from "@selector/shared/components";
import type { FC } from "react";

import type { Project } from "../../../../graphql.js";
import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const ProjectCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }
  const { colDef } = props;
  const useExternal = colDef.openLinkExternal;

  let project: Project = props.data.project;
  if (colDef.field === "dataset.project.name") {
    project = props.data.dataset.project;
  } else if (colDef.field === "sample.project.name") {
    project = props.data.sample.project;
  } else if (colDef.field === "file.project.name") {
    project = props.data.file.project;
  }

  // use display: 'inline-grid', otherwise the div inherits 'inline' which disables the ellipsis in some browsers ...
  return (
    <TableCell>
      <ProjectColoredLink project={project} forceExternal={useExternal} />
    </TableCell>
  );
};

export default ProjectCell;
